import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-issue-detailed-view',
  templateUrl: './issue-detailed-view.component.html',
  styleUrls: ['./issue-detailed-view.component.css']
})
export class IssueDetailedViewComponent implements OnInit {
  IS_Id:any;
  mode:any;
  issueresList;
  issue:any={};
  IS_Ticket_No:any;
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.IS_Id = params['IS_Id']
    );
    this.route.params.subscribe(params =>
      this.IS_Ticket_No = params['IS_Ticket_No']
    );
    this.route.params.subscribe(params =>
      this.mode = params['mode']
    );
      
    if (this.IS_Id != null && this.mode != null)
    this.GetIssueForinternTheId(this.IS_Id);
    this.GetIssueinternResponse(this.IS_Ticket_No,this.IS_Id);
  }
  GetIssueForinternTheId(IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueForinternTheId(IS_Id)
      .subscribe(
        (data: any) => {
          this.issue = data;
          if (this.issue.IS_Exp_Delivery != null)
          this.issue.IS_Exp_Delivery = ((this.issue.IS_Exp_Delivery).split('T'))[0];
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetIssueinternResponse(IS_Ticket_No,IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueinternResponse(IS_Ticket_No,IS_Id)
      .subscribe(
        (data: any) => {
          this.issueresList = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/issues/issue-detailed-view/issue-detailed-view.component.ts